import { useQuery } from '@tanstack/react-query';
import { queryKeys } from './queryKeys';
import axios from 'axios';

import {
    API_BASE_URL
} from "@/app_url"

const getHeader = () => {
    let value = JSON.parse(localStorage.getItem("doctolikLoginInfo"));
    return {
        headers: {
            Authorization: "Bearer " + value?.authorisation?.token,
        },
    };
};

// ============================================================================
// Query Hooks
// ============================================================================


/**
 * fetch notifications unread count 
 * TODO make sure to include the correct mechanism to change, add refetch technic
 */

export function useNotificationsUnreadCount(options = {}) {
    return useQuery({
        queryKey: queryKeys.notifications.notificationsUnreadCount(),
        queryFn: async ({ signal }) => {
            const response = await axios.get(`${API_BASE_URL}v1/notifications/unread-count`, getHeader());
            const serverCount = Number(response?.data?.count ?? 0);

            if (response?.data) {
                return { ...response.data, count: Math.max(0, serverCount) }
            }

            return { count: 0 }
        },
        staleTime: 0,
        gcTime: 1_000 * 60 * 60 * 4,
        refetchOnMount: 'always',
        refetchOnWindowFocus: true,
        meta: {
            persist: true
        },
        ...options
    })
}


export function useNotificationsList(options = {}) {
    return useQuery({
        queryKey: queryKeys.notifications.notificationsList(),
        queryFn: async ({ signal }) => {
            const response = await axios.get(`${API_BASE_URL}v1/notifications`, getHeader());
            if (response?.data) {
                return response?.data
            }

            return []
        },
        staleTime: 0,
        gcTime: 1_000 * 60 * 60 * 4,
        refetchOnMount: 'always',
        refetchOnWindowFocus: true,
        meta: {
            persist: true
        },
        ...options
    })
}
